import { render, staticRenderFns } from "./StoreControl.vue?vue&type=template&id=704ec1aa"
import script from "./StoreControl.vue?vue&type=script&lang=js"
export * from "./StoreControl.vue?vue&type=script&lang=js"
import style0 from "./StoreControl.vue?vue&type=style&index=0&id=704ec1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports